import { Typography } from '@analytical-alley/ui';
import { useConfigContext } from '@/context/configContext';

interface Props {
    variableName: string;
    hoveredValue: {
        value: number;
        recommendedBudget: number;
        minRecommended: number;
        maxRecommended: number;
    };
}

export const BudgetTooltip = ({ variableName, hoveredValue }: Props) => {
    const { formatNumber } = useConfigContext();

    return (
        <div className="tooltip-content">
            <table>
                <tbody>
                    {[
                        ['Variable:', variableName],
                        [
                            'Current budget step:',
                            formatNumber(hoveredValue.value),
                        ],
                        [
                            'Recommended(locked) budget:',
                            formatNumber(hoveredValue.recommendedBudget),
                        ],
                        [
                            'Minimum recommended budget:',
                            formatNumber(hoveredValue.minRecommended),
                        ],
                        [
                            'Maximum recommended budget:',
                            formatNumber(hoveredValue.maxRecommended),
                        ],
                    ].map(([label, value], index) => (
                        <tr key={index}>
                            <td className="pr-2">
                                <Typography className="text-black dark:text-black">
                                    {label}
                                </Typography>
                            </td>
                            <td>
                                <Typography className="text-dark dark:text-dark">
                                    {value}
                                </Typography>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
